module.exports = __webpack_public_path__ + "img/img_app_config_preview.cff0f1c8.png";